import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { UtenticlientPage } from '../../pages/utenticlient/utenticlient';
import { ViewordinePage } from "../../pages/viewordine/viewordine";

/**
 * Generated class for the EdituserclientPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-edituserclient',
  templateUrl: 'edituserclient.html',
})
export class EdituserclientPage {
  userclient;
  searchTerm;
  cat = "utente";
  indirizzo;
  errorMessage;
  ordinazioni;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,
    private readonly loadingCtrl: LoadingController

  ) {
    this.userclient = navParams.get('userclient');
    this.searchTerm = navParams.get('searchTerm');
    this.getAddressConsegna();
    this.getOrdinazioni()
  }
  getAddressConsegna() {



    this.rest.getAddressConsegna(this.userclient).subscribe(
      addressConsegna => {
        // alert(JSON.stringify(addressConsegna))
        if (JSON.stringify(addressConsegna) != "{}") {
          this.indirizzo = addressConsegna
        }


      },
      error => this.errorMessage = <any>error);

  }

  getOrdinazioni() {

    this.rest.getOrdineLastTen(this.userclient).subscribe(
      ordinazioni => {
        this.ordinazioni = ordinazioni;
        //alert("ciao")
        //alert(JSON.stringify(ordinazioni));
      },
      error => {
        this.errorMessage = <any>error
        // alert(error)

      });

  }

  viewOrdine(ordine) {

    this.navCtrl.push(ViewordinePage, { ordine: ordine });


  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad EdituserclientPage');
  }
  updateUserClient() {
    let loading = this.loadingCtrl.create({

      spinner: 'bubbles',
      duration: 3000,

      content: 'save ...'

    });
    this.rest.aggiornaUser(this.userclient);
    this.navCtrl.push(UtenticlientPage, { searchTerm: this.searchTerm }).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });

  }
  swipeEvent(e) {}

}



// WEBPACK FOOTER //
// ./src/pages/edituserclient/edituserclient.ts